import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import history from 'helpers/history';

import EndOfDayReports from './menus/EndOfDayReports';
import SalesSummaryReports from './menus/SalesSummaryReports';
import AllPaymentsReports from './menus/AllPaymentsReports';
import VendorSummaryReports from './menus/VendorSummaryReports';
import AllInvoicesReports from './menus/AllInvoicesReports';
import UnpaidInvoices from './menus/UnpaidInvoices';
import PaidInvoices from './menus/PaidInvoices';
import AccountsReceivableList from './menus/AccountsReceivableList';

interface ComponentState {
    activeMenuIndex?: number;
}

interface Props {
    dispatch: Dispatch;
}

class ReportsPage extends React.Component<Props, ComponentState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            activeMenuIndex: undefined,
        };
    }

    componentDidMount() {
        //@ts-ignore
        const { subpageName } = this.props.match.params;
        this.setActiveMenu(subpageName);
    }

    setActiveMenu(subpageName: string) {
        let activeMenuIndex = navigationItems
            .flatMap((item) => item.pages)
            .findIndex((menuItem) => menuItem.location === subpageName);
        if (activeMenuIndex === -1) activeMenuIndex = 0;
        this.setState({ activeMenuIndex });
    }

    render() {
        const { activeMenuIndex } = this.state;
        return (
            <div className="flex">
                <div className="w-60 bg-white border-r border-gray-200 flex-shrink-0 h-screen fixed overflow-y-auto">
                    <div className="fixed w-60 bg-white  h-screen p-6 border-r border-gray-200">
                        <h1 className="text-2xl font-bold text-gray-900 mb-8">Reports</h1>
                        <div className="space-y-8">
                            {navigationItems.map((group, groupIndex) => {
                                return (
                                    <div key={`reportGroup${groupIndex}`}>
                                        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
                                            {group.groupName}
                                        </h3>
                                        <div className="space-y-1">
                                            {group.pages.map((report, _) => {
                                                return (
                                                    <button
                                                        key={report.location}
                                                        onClick={() => {
                                                            history.push(`/reports/${report.location}`);
                                                            this.setState({ activeMenuIndex: report.index });
                                                        }}
                                                        className={`w-full flex items-center px-3 py-2.5 text-sm font-semibold rounded-lg transition-colors text-left ${
                                                            activeMenuIndex === report.index
                                                                ? 'bg-blue-50 text-blue-700 border border-blue-200'
                                                                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                                                        }`}
                                                    >
                                                        <span className="truncate">{report.name}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                {!(activeMenuIndex === undefined) && (
                    <div className="flex-1 flex flex-col min-w-0 pl-60">
                        <div className="flex-1 overflow-y-auto p-4 pb-96">
                            {
                                navigationItems
                                    .flatMap((item) => item.pages)
                                    .find((report) => report.index === activeMenuIndex)!.component
                            }
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const navigationItems: {
    groupName: string;
    pages: { name: string; location: string; component?: React.ReactElement; index: number }[];
}[] = [
    {
        groupName: 'Overview',
        pages: [
            {
                name: 'End of Day ',
                location: 'eodReports',
                component: <EndOfDayReports />,
                index: 0,
            },
            {
                name: 'Sales Summary',
                location: 'salesSumary',
                component: <SalesSummaryReports />,
                index: 1,
            },
        ],
    },
    {
        groupName: 'Payments Reports',
        pages: [
            {
                name: 'All Payments',
                location: 'allPayments',
                component: <AllPaymentsReports />,
                index: 2,
            },
            {
                name: 'A/R',
                location: 'accountsReceivable',
                component: <AccountsReceivableList />,
                index: 3,
            },
        ],
    },
    {
        groupName: 'Purchase Orders',
        pages: [
            {
                name: 'Vendor Summary',
                location: 'vendorSummary',
                component: <VendorSummaryReports />,
                index: 4,
            },
        ],
    },
    {
        groupName: 'Estimates and Invoices',
        pages: [
            {
                name: 'All Invoices',
                location: 'allInvoices',
                component: <AllInvoicesReports />,
                index: 5,
            },
            {
                name: 'Unpaid Invoices',
                location: 'unpaidInvoices',
                component: <UnpaidInvoices />,
                index: 6,
            },
            {
                name: 'Paid Invoices',
                location: 'paidInvoices',
                component: <PaidInvoices />,
                index: 7,
            },
        ],
    },
];

export default connect()(ReportsPage);
